import FilterComponent from "../../PainelCovid/Apresentacao/FilterComponent";
import * as Styles from "./styles";
import {states} from '../../PainelCovid/Apresentacao/data-local/estados-hashtable.json'

export function Apresentacao({ queryState, setState }) {
  return (
    <Styles.PresentationContainer>
        <Styles.PresentationContent>
          <Styles.PresentationHeadling>
            <Styles.PresentationHeader>
            Painel de sentimentos e satisfação dos(as) trabalhadores(as) da saúde
            </Styles.PresentationHeader>
            <FilterComponent
              options={states}
              title={"Estado"}
              onChange={setState}
              value={queryState}
              placeholder={"Selecione um estado"}
            />
          </Styles.PresentationHeadling>
        </Styles.PresentationContent>
      </Styles.PresentationContainer>
  );
}
